import React from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle, Home, FileText } from 'lucide-react';

const CertifiedNetworkConfirmationPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-green-50 to-blue-50 dark:from-gray-900 dark:to-gray-800 py-12 px-4">
      <div className="max-w-2xl mx-auto">
        {/* Success Card */}
        <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-xl p-8 text-center">
          {/* Success Icon */}
          <div className="mb-6">
            <div className="mx-auto w-20 h-20 bg-green-100 dark:bg-green-900/30 rounded-full flex items-center justify-center">
              <CheckCircle className="w-12 h-12 text-green-600 dark:text-green-400" />
            </div>
          </div>

          {/* Title */}
          <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-4">
            Domanda Inviata con Successo!
          </h1>

          {/* Message */}
          <div className="mb-8 space-y-4">
            <p className="text-lg text-gray-700 dark:text-gray-300">
              La tua domanda di iscrizione alla <strong>Rete Certificata UNASCA</strong> è stata inviata correttamente.
            </p>
            
            <div className="bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded-lg p-4">
              <p className="text-sm text-blue-800 dark:text-blue-300">
                <strong>Cosa succede ora?</strong>
              </p>
              <ul className="text-sm text-blue-700 dark:text-blue-400 mt-2 space-y-2 text-left">
                <li className="flex items-start">
                  <span className="mr-2">•</span>
                  <span>Il nostro team esaminerà la tua domanda entro 5-7 giorni lavorativi</span>
                </li>
                <li className="flex items-start">
                  <span className="mr-2">•</span>
                  <span>Riceverai una email di conferma all'indirizzo indicato</span>
                </li>
                <li className="flex items-start">
                  <span className="mr-2">•</span>
                  <span>Ti contatteremo per comunicarti l'esito della valutazione</span>
                </li>
              </ul>
            </div>

            <p className="text-gray-600 dark:text-gray-400">
              Se hai domande o necessiti di assistenza, non esitare a contattarci.
            </p>
          </div>

          {/* Action Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors font-medium"
            >
              <Home className="w-5 h-5" />
              Torna alla Home
            </Link>
            
            <Link
              to="/contact"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-white dark:bg-gray-700 text-gray-700 dark:text-gray-200 border border-gray-300 dark:border-gray-600 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-600 transition-colors font-medium"
            >
              <FileText className="w-5 h-5" />
              Contattaci
            </Link>
          </div>
        </div>

        {/* Additional Info */}
        <div className="mt-8 text-center">
          <p className="text-sm text-gray-600 dark:text-gray-400">
            Hai ricevuto questa conferma perché hai completato la domanda di iscrizione alla Rete Certificata UNASCA.
          </p>
        </div>
      </div>
    </div>
  );
};

export default CertifiedNetworkConfirmationPage;

